<div
    #inputElement
    class="form-group form-horizontal input-with-clear clickable"
>
    <i class="fa fa-dollar amount-icon" aria-hidden="true"> </i>
    <input
        [ngClass]="{ 'is-invalid': isInvalid() }"
        placeholder=""
        class="form-control clickable"
        type="text"
        [(ngModel)]="value"
        [mask]="mask.currencyMask"
    />
    @if (showClear()) {
        <span class="input-with-clear-img" (click)="onClear($event)"
            >&#10006;</span
        >
    }
</div>
